import { useSearchParams } from 'react-router-dom';

import { LineAddFriendModal, PageWrapper, Text } from 'components';
import { LINE_ADD_FRIEND_BASE_URL, TEXT_STRING } from '../../constants';

function RichMenuAddFriend() {
  const [searchParams] = useSearchParams();
  const basicId = searchParams.get('basicId')?.trim() ?? '';
  const lineAddFriendUrl = basicId
    ? `${LINE_ADD_FRIEND_BASE_URL}${basicId}`
    : '';

  if (!basicId) {
    return (
      <PageWrapper className="flex flex-col justify-center items-center w-full h-full p-4">
        <Text center fontSize={16}>
          {TEXT_STRING.COMMON.SOMETHING_WENT_WRONG}
        </Text>
      </PageWrapper>
    );
  }

  return <LineAddFriendModal isOpen lineAddFriendUrl={lineAddFriendUrl} />;
}

export default RichMenuAddFriend;
